import { render } from "./_PdfAula.vue?vue&type=template&id=39711235&scoped=true"
import script from "./_PdfAula.vue?vue&type=script&lang=ts"
export * from "./_PdfAula.vue?vue&type=script&lang=ts"

import "./_PdfAula.vue?vue&type=style&index=0&id=39711235&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-39711235"

export default script